import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { setAgreementType } from 'bundles/apex/deals/form/store/deal/actions';

import DealField from 'bundles/apex/deals/form/fields/field';

import ManagedFormGroup from 'components/form/managed_input/form_group';

export function AgreementType({ deal, options, setAgreementType }) {
  return (
    <ManagedFormGroup
      includeBlank
      label="Agreement Type"
      type="select"
      value={deal.agreementType}
      onValueChange={setAgreementType}
    >
      {options.map(option => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </ManagedFormGroup>
  );
}

AgreementType.propTypes = {
  deal: PropTypes.shape({
    agreementType: PropTypes.string,
    id: PropTypes.number,
  }).isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
  setAgreementType: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  deal: state.deal,
  options: state.options.agreementType,
});

const mapDispatchToProps = {
  setAgreementType,
};

export default connect(mapStateToProps, mapDispatchToProps)(DealField(AgreementType, 'agreementType'));
